import request from 'helpers/request';
import api from 'config';

// 대장포인트 사용타입 코드
export const MyPointTypeList = () =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/mypoint/type`
  });

// 대장포인트 상태 코드
export const MyPointStatusList = () =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/mypoint/status`
  });

// 대장포인트 내역
export const MyPointList = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/mypoint`,
    params
  });

// 사용자별 식대 지급/사용 내역
export const UserSikdaeGivenList = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/user`,
    params
  });

// 사용자별 식대 지급/사용 합계
export const UserSikdaeGivenTotal = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/user/total`,
    params
  });

// 사용자별 식대 지급/사용 상세
export const UserSikdaeGivenDtl = (id, params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/user/${id}`,
    params
  });

// 사용자별 식대 사용 내역 v2
export const UserSikdaeUsageHistory = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v2/user`,
    params
  });

// 사용자별 식대 사용 합계 v2
export const UserSikdaeUsageTotal = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v2/user/total`,
    params
  });

// 사용자별 식대 사용 상세 v2
export const UserSikdaeUsageDetail = (id, params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v2/user/${id}`,
    params
  });

// 사용자별 식대 지급/차감 내역
export const UserSikdaeGrandDeductHistory = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/grant-deduct`,
    params
  });
export const UserSikdaeGrandDeductTotal = (params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/grant-deduct/total`,
    params
  });
// 사용자별 식대 지급/차감 상세
export const UserSikdaeGrandDeductDetail = (id, params) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/grant-deduct/${id}`,
    params
  });
// 가맹점 통계
export const StoreStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/store`,
    params
  });

// 부서 통계
export const DivisionStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/division`,
    params
  });

// 식대그룹 통계
export const GroupStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/group`,
    params
  });

// 식대사용 통계
export const UsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/coupon`,
    params
  });

// 식대사용 통계 합계
export const UsageStatsTotal = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/totalcoupon`,
    params
  });

// 식대 사용내역 > 삼성물산 급여공제
export const DeductionSamsungCNTUsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/samsung-cnt/salary-deduction`,
    params
  });

// 식대 사용내역 > 삼성카드 급여공제
export const DeductionSamsungCardUsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/samsung-card/salary-deduction`,
    params
  });

// 식대 사용내역 > 삼성카드 급여공제 통계 합계
export const DeductionSamsungCardUsageStatsTotal = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/samsung-card/salary-deduction/total`,
    params
  });

// 식대 사용내역 > 웰컴시스템아이엔씨 급여공제
export const DeductionWelcomeSystemINCUsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/welcome-system-inc/salary-deduction`,
    params
  });

// 식대 사용내역 > 삼성의료재단 급여공제
export const DeductionSamsungMedicalUsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/samsung-medical/salary-deduction`,
    params
  });

// 식대 사용내역 > 김앤장 급여공제
export const DeductionKimAndChangUsageStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/kim-and-chang/salary-deduction`,
    params
  });

// 식대상세 조회
export const SikdaeDtlList = (params) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/coupon/v1/room`,
    data: params
  });

// 식대상세 조회 statement 생성
export const CreateSikdaeDtlStatement = (params, config) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/stat/v1/room`,
    data: params,
    config
  });

// 식대상세 조회 statement 상태 조회
export const SikdaeDtlStatementStatus = (statementId, config) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/statements/${statementId}/status`,
    config
  });

// 식대상세 조회 statement 결과 조회
export const SikdaeDtlStatementResult = (statementId, params, config) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/room/${statementId}`,
    params,
    config
  });

// 삼성 SDS 식대상세 조회 statement 생성
export const CreateSamsungSdsSikdaeDtlStatement = (params, config) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/stat/v1/company/samsung-sds/policy-amount`,
    data: params,
    config
  });

// 삼성 SDS 식대상세 조회 statement 결과 조회
export const SamsungSdsSikdaeDtlStatementResult = (statementId, params, config) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/samsung-sds/policy-amount/${statementId}`,
    params,
    config
  });

// 식대상세 조회 statement 취소
export const CancelSikdaeDtlStatement = (statementId, config) =>
  request({
    method: 'post',
    url: `${api.config.companyAPI}/stat/v1/statements/${statementId}/cancel`,
    config
  });

// 식대상세 조회 statement 엑셀 생성 요청
export const CreateSikdaeDtlExcel = (params, config) =>
  request({
    method: 'post',
    url: `${api.config.companyAPI}/stat/v1/room/excel`,
    data: params,
    config
  });

// 삼성 SDS 식대상세 조회 엑셀 생성 요청
export const CreateSamsungSdsSikdaeDtlExcel = (params, config) =>
  request({
    method: 'post',
    url: `${api.config.companyAPI}/stat/v1/company/samsung-sds/policy-amount/excel`,
    data: params,
    config
  });

// 식대상세 엑셀용 리스트 조회
export const SikdaeDtlExcelList = (params, config) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/coupon/v1/excel/rooms`,
    data: params,
    config
  });

// 식대상세 조회 - 상세
export const SikdaeListDtl = (couponid) =>
  request({
    url: `${api.config.companyAPI}/coupon/v1/room/${couponid}`
  });

// 식대상세 조회 엑셀 다운로드
export const ExcelSikdaeDtlList = (params) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/coupon/v1/room/download`,
    data: params
  });

// 청구서 내역 조회
export const BillDtl = (idx, params) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/account/${idx}/`,
    params
  });

// 청구서 승인, 승인취소
export const BillAccepted = (method, data, pIdx, iIdx) =>
  request({
    method,
    url: `${api.config.companyAPI}/bill/v1/account/${pIdx}/invoice/${iIdx}/approval`,
    data
  });

// 청구서 반려
export const BillRejected = (data, pIdx, iIdx) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/bill/v1/account/${pIdx}/invoice/${iIdx}/approval`,
    data
  });

export const BillParentRejected = (data, pIdx, iIdx) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/bill/v1/account/${pIdx}/invoice/${iIdx}/approval/parent`,
    data
  });

// 청구목록 그룹, 계좌 조회
export const BillGroupList = (params) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/account/`,
    params
  });

// 청구서 날짜 조회
export const BillDateList = (params) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/date`,
    params
  });

// 청구서 식대 상세 조회
export const BillDetList = (iIdx, params) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/invoice/${iIdx}/usageHistory`,
    params
  });

// 청구서 식대 상세 조회 total
export const BillDetTotal = (iIdx) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/invoice/${iIdx}/usageHistoryTotal`
  });

// 청구서 결재 라인 조회
export const BillApprovalStepList = (iIdx, params) =>
  request({
    url: `${api.config.companyAPI}/bill/v1/account/${iIdx}/approvalStep`,
    params
  });

// 청구서 결재 라인 수정
export const BillApprovalStepMod = (iIdx, params) =>
  request({
    method: 'put',
    url: `${api.config.companyAPI}/bill/v1/account/${iIdx}/approvalStep`,
    data: params
  });

// 청구서 재발행
export const BillReturnStepMod = (data, pIdx, iIdx) =>
  request({
    method: 'post',
    url: `${api.config.companyAPI}/bill/v1/account/${pIdx}/invoice/${iIdx}/reissue`,
    data
  });

// 아워홈 포인트 차감 통계
export const OurhomeSubtractStatsList = (params) =>
  request({
    url: `${api.config.companyAPI}/stat/v1/company/subtract`,
    params
  });

// 바코드 사용자 목록 조회
export const BarcodeMembers = (params) => {
  return request({ url: `${api.config.companyAPI}/company/v1/barCode/member`, params });
};

// 바코드 사용자 목록 조회
export const BarcodeHistories = (barCodeStaticIdx) => {
  return request({ url: `${api.config.companyAPI}/company/v1/barCode/history/${barCodeStaticIdx}` });
};

// 바코드 정보 생성
export const CreateBarcode = (data) => {
  return request({ method: 'post', url: `${api.config.companyAPI}/company/v1/barCode`, data });
};

// 바코드 정보 등록 bulk
export const CreateBarcodeBulk = (data) => {
  return request({ method: 'post', url: `${api.config.companyAPI}/company/v1/barCode/bulk`, data });
};

// 바코드 정보 수정
export const UpdateBarcode = (data) => {
  return request({ method: 'put', url: `${api.config.companyAPI}/company/v1/barCode`, data });
};
